import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledDateContainer = styled(Box, {
  display: 'flex',
  alignItems: 'center',
});

export const StyledSubPageHeader = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '$7',
  width: '100%',
  variants: {
    isSticky: {
      true: {
        alignItems: 'center',
        backgroundColor: '$white',
        borderBottom: '$borderWidths$1 solid $grey200',
        boxShadow: '$stickyNav',
        display: 'flex',
        height: '$stickyNav$height',
        justifyContent: 'space-evenly',
        left: '0',
        margin: '0',
        overflow: 'visible',
        paddingLeft: '$studyInsights$sidebarWidthClose',
        position: 'fixed',
        transition: 'top 400ms ease-in-out 0s',
        width: '100%',
        zIndex: '$stickyHeader',
      },
    },
  },
});

export const StyledSelectedRange = styled(Box, {
  alignItems: 'center',
  color: '$darkBlue200',
  display: 'flex',
  fontSize: '$4',
  fontWeight: '$regular',
  lineHeight: '$6',
});

export const StyledDate = styled(Box, {
  marginLeft: '$4',
  fontWeight: '$bold',
  lineHeight: '$6',
});

export const StyledSelectContainer = styled(Box, {
  marginLeft: '$4',
});

export const StyledSubPageContainer = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  maxWidth: '$studyInsights$headerMaxWidth',
  width: '100%',
});

export const StyledLayoutOneContent = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
});

export const StyledInfoPanel = styled(Box, {
  alignItems: 'flex-end',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

export const StyledBaseline = styled(Box, {
  border: '2px dashed #7ACB71',
  width: '30%',
});

export const StyledDescription = styled(Box, {
  color: '$darkBlue300',
  display: 'flex',
});
